export default __webpack_public_path__ + "img/399a2c98231c629dede776d8b0a443ed.jpg";